import { TierDto, TierTypes } from 'legacy/events/types';

const computeInitialValues = (
  ticket: TierDto,
  isTierPrivate: boolean
): TierDto =>
  ticket
    ? {
        ...ticket,
        maxAttendance: ticket.maxAttendance,
        startDate: ticket.startDate,
        endDate: ticket.endDate,
        totalGuests: ticket.totalGuests || 0,
        canDelete: ticket.canDelete || false,
        type: ticket.type
      }
    : {
        id: '',
        type: TierTypes.Admission,
        isDisabled: false,
        name: '',
        description: '',
        price: undefined,
        isPrivate: isTierPrivate,
        requiresApproval: false,
        imageUrl: undefined,
        totalGuests: 0,
        canDelete: true,
        requiredOrganizationIds: [],
        requiredAssociationIds: []
      };

export default computeInitialValues;
